module.exports = __webpack_public_path__ + "img/JKA_banner.84c279f6.svg";